import EdLayoutBasic from './ed-layout-basic/ed-layout-basic.vue';
import EdLayoutSidebar from './ed-layout-sidebar/ed-layout-sidebar.vue';

export const Layouts = {
  EdLayoutSidebar: EdLayoutSidebar, 
  EdLayoutBasic: EdLayoutBasic,  
}